import * as v from "valibot";
import { baseVals, defineValidation } from "../../common/validation.common";
import { MaintenanceTypeEnum } from "../../data/enums";

export namespace DevToolsValidation {
    export const ToggleMaintenance = defineValidation(
        v.object({
            which: v.picklist(MaintenanceTypeEnum.values),
            active: v.boolean(),
        }),
    );

    export const Daemon = defineValidation(
        v.object({
            key: baseVals.string(),
            date: baseVals.isoDate(),
        }),
    );
}
